import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Tabs, Button } from "antd";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchCompanyLosProfileList } from "./actions";
import { CompanyLosProfileTable } from "./templates";
import { STATE_STATUS } from "./constants";
import { COMPANY_LOS_PROFILE_COLS } from "./constants/table-columns";
import PopMenu from "components/PopMenu";
import { Map } from "immutable";
const tabs = [
    {
        label: "Anchor",
        value: "1",
    },
    {
        label: "Distributor",
        value: "2",
    },
    {
        label: "Retailer",
        value: "3",
    }];

class CompanyLosProfiles extends React.Component {

    state = {
        activeKey: "2"
    };

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    async fetchData() {
        if (this.props.status === STATE_STATUS.UNFETCHED) {
            this.props.fetchCompanyLosProfileList(this.props.filters);
        }
    }

    isLoading() {
        if (this.props.status === STATE_STATUS.FETCHING) {
            return true;
        }
        return false;
    }


    onPageChange = (page, pageSize) => {
        this.props.fetchCompanyLosProfileList({ ...this.props.filters, page, page_size: pageSize });
    }

    filterObj = {};

    onFilter = search => {
        this.filterObj = {};
        new Map(search).map((_, k) => {
            // if(k === "search" && _ && _[0]) {
            //     this.filterObj["name"] = _ && _[0];
            // } 
            // else 
            if (_ && typeof _ && _[0] === "object") {
                if (_[0].max && _[0].max._isAMomentObject) {
                    this.filterObj[k] = JSON.stringify([_[0].min && _[0].min.format("YYYY-MM-DD"), _[0].max && _[0].max.format("YYYY-MM-DD")]);
                } else {
                    this.filterObj[k] = JSON.stringify([_[0].min, _[0].max]);
                }
            }
            // else if (k === "name") {
            //     if(_ && _[0]) {
            //         this.filterObj[k] == _[0];
            //     }
            // } 
            else {
                this.filterObj[k] = _ && _[0];
            }
        });
        const { page, page_size } = this.props.filters;
        this.props.fetchCompanyLosProfileList({ page, page_size, ...this.filterObj, type: this.state.activeKey });
    }

    handleItemClick = () => {
        this.props.history.push("/app/companies/create");
    }

    onTabChange = activeKey => {
        this.setState({
            activeKey
        }, () =>
            this.props.fetchCompanyLosProfileList({ ...this.props.filters, ...this.filterObj, type: activeKey })
        );
    }

    render() {
        const { companies, filters, pages, totalCount } = this.props;
        const currentPageIds = pages.get(filters.page);
        const data = companies.filter(_ => currentPageIds.includes(_.id)).toList();
        return (
            <React.Fragment>
                <PopMenu
                    icon={"plus"}
                    onItemClick={this.handleItemClick}
                    menuList={["Add New Company"]}
                />
                <Row className={"p-5 h-100"}>
                    <Col span={24} className="d-flex justify-content-space-between">
                        <Tabs defaultActiveKey={this.state.activeKey} onChange={this.onTabChange} >
                            {tabs.map(({ label, value }) => {
                                return (<Tabs.TabPane tab={label} key={value}>{null}</Tabs.TabPane>);
                            })}
                        </Tabs>
                        <a href="https://chitthi.s3.amazonaws.com/media/public/assests/Visibility_Generation_Steps.pdf" target="_">
                            <Button type="primary" > Visiblity Generation </Button>
                        </a>
                    </Col>
                    <Col span={24}>
                        <CompanyLosProfileTable
                            columns={this.state.activeKey == '1' ?  COMPANY_LOS_PROFILE_COLS :COMPANY_LOS_PROFILE_COLS.filter((_, key) => key != 'is_anchor_aligned') }
                            loading={this.isLoading()}
                            data={data}
                            currentPage={filters.page}
                            totalCount={totalCount}
                            onPageChange={this.onPageChange}
                            onFilter={this.onFilter} />
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

}

CompanyLosProfiles.propTypes = {
    companies: PropTypes.object,
    filters: PropTypes.object,
    status: PropTypes.string,
    pages: PropTypes.object,
    totalCount: PropTypes.number,
    fetchCompanyLosProfileList: PropTypes.string,
    history: PropTypes.object
};

CompanyLosProfiles.defaultProps = {
    totalCount: 0
};


const mapStateToProps = state => ({
    status: state.companyLosProfiles.getIn(["list", "status"]),
    companies: state.companyLosProfiles.getIn(["list", "data"]),
    filters: state.companyLosProfiles.getIn(["list", "filters"]),
    totalCount: state.companyLosProfiles.getIn(["list", "totalCount"]),
    pages: state.companyLosProfiles.getIn(["list", "pages"])
});

const mapDispatchToProps = dispatch => bindActionCreators({
    fetchCompanyLosProfileList
}, dispatch);


const CompanyLosProfilesWrapped = connect(mapStateToProps, mapDispatchToProps)(CompanyLosProfiles);

export default CompanyLosProfilesWrapped;